import { IEnvironment } from "environments/model"
import { environmentsRPO } from "environments/repository"

export const searchEnvironmentsByName = (filter: string): Promise<IEnvironment[]> =>
  environmentsRPO.getEnvironmentsByName(filter)
